// @flow

import { freeze } from "icepick";
import { CLEAR_STOPS, FETCH_STOPS_SUCCESS, FETCH_STOPS_ERROR } from "./actions";

import type { MapState } from "./types";

const initialState: MapState = freeze({
    all: null
});

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CLEAR_STOPS:
            return freeze({
                ...state,
                all: null
            });
        case FETCH_STOPS_SUCCESS:
            return freeze({
                ...state,
                all: payload
            });
        case FETCH_STOPS_ERROR:
            return freeze({
                ...state,
                hasErrors: true
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/map/reducer.js